import React, { useContext, useEffect, useState, useRef } from "react";
import { green } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { Button, Switch } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import "../css/header.css";
import axios from "axios";
import { updateServiceStatus } from "../utils/api";
import Logout from "./Logout";
import Context from '../context/context';
import { ThreeSixty, ToggleOff } from "@mui/icons-material";

const GreenSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: green[500],
    "&:hover": {
      backgroundColor: alpha(green[500], theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: green[500],
  },
}));

const Header = () => {
  const context = useContext(Context);
  const { setInventoryPageContent, bulkUploadedData } = context;
  const [dropdown, setDropdown] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const ref = useRef();
  const page = window.location.pathname;

  const Navigate = useNavigate();
  const selectedPage = sessionStorage.getItem("selected-page") || "/page1";
  const [services, setServices] = useState([
    { name: "Dine In", id: "Dine-in", status: false, serviceStatus: "" },
    { name: "Delivery", id: "Delivery", status: false, serviceStatus: "" },
    { name: "Take Away", id: "Pick-up", status: false, serviceStatus: "" },
    { name: "Meals", id: "Schedule", status: false, serviceStatus: "" },
    { name: "Zomato", id: "Zomato", status: false, serviceStatus: "" },
    { name: "Swiggy", id: "Swiggy", status: false, serviceStatus: "" },
  ]);

  const handleClick = (e, item) => {
    updateServiceStatus(item.id, { button_status: !item.status ? 1 : 0 });
    setServices((prevState) =>
      prevState.map((service) =>
        service.name === item.name
          ? { ...service, status: !service.status }
          : service
      )
    );
  };
  // console.log("page", location.pathname)

  const getData = () => {
    var apiResponse;
    const data = JSON.stringify([
      {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      },
    ]);

    const config = {
      method: "post",
      url: "https://api.myfooddo.com/outlet/GetServiceStatus",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        apiResponse = response.data.result;
        console.log("api resonse", apiResponse);
        setServices((prevState) => [
          ...prevState.map((item) => {
            const [{ button_status, service_status }] = apiResponse.filter(
              (e) => e.service_name === item.id
            );
            return {
              ...item,
              status: parseInt(button_status) > 0 ? true : false,
              serviceStatus: service_status,
            };
          }),
        ]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the dropdown is open and the clicked target is not within the dropdown,
      // then close the menu
      if (dropdown && ref.current && !ref.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [dropdown]);

  return (
    <div className="header">
      <h1>{localStorage.getItem("outlet-name")}</h1>
      <div className="header_right">
        <div style={{ hight: "100%", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "15px", marginRight: "10px" }}>

          <div>{Object.keys(bulkUploadedData).length ? bulkUploadedData.total - bulkUploadedData?.count + "/" + bulkUploadedData.total + " Items Uploaded" : ""}</div>
        </div>
        {page.includes('Inv-Ac') ?
          <div style={{ display:'flex', alignItems: 'center'}}>
            <Button onClick={() => Navigate('/page1')} variant="contained" startIcon={<ThreeSixty />} style={{backgroundColor:'#44cd4a', fontWeight: 'bold'}}>
              POS
            </Button>
          </div> 
        :
          <div className="header_toggle_btn" ref={ref}>
            <ToggleOff
              className="icon_btn"
              onClick={() => {
                !dropdown && getData();
                setDropdown((prevState) => !prevState);
              }}
            />
            {dropdown ? (
              <div className="toggle_dropdown">
                {/* Toggle buttons */}
                {services
                  .filter((service) => service.serviceStatus === "Y")
                  .map((item, index) => (
                    <div
                      key={item + "_" + index}
                      className="toggle_dropdown_item"
                    >
                      {item.name}{" "}
                      <GreenSwitch
                        onClick={(e) => handleClick(e, item)}
                        checked={item.status}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              ""
            )}
          </div>
        }
        <div className="header_right_link"
          onClick={() => {
            if (page.includes('Inv-Ac')) {
              Navigate('/Inv-Ac')
              setInventoryPageContent('');
            } else {
              !page.includes(selectedPage) && Navigate(selectedPage)
            }
          }}
        >
          Dashboard
        </div>
        <div className="header_right_link" onClick={() => setLogoutPopup(true)}>
          Logout
        </div>
      </div>
      {logoutPopup ? <Logout onClose={() => setLogoutPopup(false)} /> : ""}

    </div>
  );
};
export default Header;
